export default function departmentDirective() {
  return {
    template: require('./department.html'),
    controller: 'DepartmentController',
    controllerAs: 'departmentVM',
    scope: {
      customerId: '<',
      department: '=',
      isIt: '='
    },
    bindToController: true,
    replace: true
  };
}
